import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Loader } from "@/components/Common";
import { api, errMsg } from "@/lib/api";

export default function CareMatchUnsubscribe() {
  const [sp] = useSearchParams();
  const [state, setState] = useState({ busy: true });
  useEffect(() => {
    api.post("/carematch/email-unsubscribe", { token: sp.get("token") || "" })
      .then(() => setState({ ok: true })).catch((e) => setState({ error: errMsg(e) }));
  }, [sp]);
  if (state.busy) return <Loader label="Updating your email preferences" />;
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="carematch-unsubscribe">
      <h1 className="text-3xl font-bold text-[#003B2D]">{state.ok ? "You're unsubscribed" : "This link didn't work"}</h1>
      <p className="text-slate-600 mt-3">{state.ok ? "You won't receive CareMatch™ emails anymore. In-app alerts and your saved searches are unchanged." : state.error}</p>
      <Button asChild className="rounded-full bg-[#003B2D] mt-6"><Link to="/account">Manage CareMatch in My Zunvel</Link></Button>
    </div>
  );
}
